// routes/FrontendRoutes.js

import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import Nudges from '../components/Frontend/BenchmarkDetails/Nudges/Nudges';

export const nudgesRoutes = (
  <>
    <Route path="/nudges" element={<MainLayout />}>
      <Route index element={<Nudges />} />
    </Route>
  </>
);
